interface IProps {
  icon: JSX.Element;
  message: string;
}

const PendingStateScreen = ({ icon, message }: IProps) => {
  return (
    <div className="flex items-center justify-center h-[100%]">
      <div className="flex flex-col items-center justify-center gap-6">
        <span>{icon}</span>
        <p className="text-center font-body font-normal text-gray-600 text-base lg:w-full w-[70%]">
          {message}
        </p>
      </div>
    </div>
  );
};

export default PendingStateScreen;
